/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelPaymentDto
 */
export interface CancelPaymentDto {
    /**
     * 
     * @type {string}
     * @memberof CancelPaymentDto
     */
    terminalId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CancelPaymentDto
     */
    isUsingHub: boolean;
}

/**
 * Check if a given object implements the CancelPaymentDto interface.
 */
export function instanceOfCancelPaymentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "terminalId" in value;
    isInstance = isInstance && "isUsingHub" in value;

    return isInstance;
}

export function CancelPaymentDtoFromJSON(json: any): CancelPaymentDto {
    return CancelPaymentDtoFromJSONTyped(json, false);
}

export function CancelPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelPaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'terminalId': json['terminalId'],
        'isUsingHub': json['isUsingHub'],
    };
}

export function CancelPaymentDtoToJSON(value?: CancelPaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'terminalId': value.terminalId,
        'isUsingHub': value.isUsingHub,
    };
}

